import React, { useState, useEffect } from 'react';
import '../components/Membercss.css';

export default function Member() {
    const [data, setData] = useState([]);
    const getData = () => {
        fetch('/member.json', {
            headers: {
                'content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then((response2) => {
            return response2.json()
        }).then((myresponse2) => {
            setData(myresponse2);
        });

    }

    useEffect(() => {
        getData();
    }, []);

    return (
        <div>
            <div className='part1'>
                <h1 style={{ color: 'white' }}><u>Lifetime Members of <span style={{ color: 'orange' }}>UPAAC</span></u></h1>
            </div>
            <div className='text-start my-5'>
                <table className='container'>
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>ID</th>
                            <th style={{ width: "50%" }}>NAME</th>
                            <th style={{ width: "30%" }}>DATE OF JOINING</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.Name}</td>
                                <td>{item.doj}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
